import React from 'react';
import { SmlsModal, SmlsButton } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';

import { ErrorModalProps } from './types';

const ErrorModal = ({ isOpen = false, onClose, toggleModal }: ErrorModalProps) => {
  const { t } = useTranslation('error_modal');

  return (
    <SmlsModal isOpen={isOpen} toggle={toggleModal} defaultHeader className="suspended-user-modal" type="right">
      <div className="default-modal-message error">
        <h4>{t('title')}</h4>
        <p>{t('subtitle')}</p>
        <SmlsButton text={t('button')} color="primary" type="button" onClick={onClose} />
      </div>
    </SmlsModal>
  );
};

export default ErrorModal;
